/** Max length enforced by PUT /enterprises. */
export const ANNOUNCEMENT_MAX_MESSAGE = 500;

export function todayYmd(now = new Date()) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function announcementDismissKey({ enterpriseId, uid, version }) {
  return `riverr.enterpriseAnnouncement.${enterpriseId || "unknown"}.${
    uid || "anon"
  }.v${Number(version) || 0}`;
}

/**
 * Whether the enterprise announcement should appear (ignores per-user dismiss).
 * Date window is inclusive, compared as local YYYY-MM-DD.
 */
export function isAnnouncementActive(banner, now = new Date()) {
  if (!banner?.enabled) return false;
  const message = String(banner.message || "").trim();
  if (!message) return false;
  const today = todayYmd(now);
  if (banner.startsAt && today < banner.startsAt) return false;
  if (banner.endsAt && today > banner.endsAt) return false;
  return true;
}
